const routes = [
  {
    path: '/instructions',
    name: 'instructions',
    component: () => import('./views/Instructions/index.vue'),
    meta: {
      title: 'Инструкции',
    },
  },
  {
    path: '/instruction/:id',
    name: 'instruction-id',
    component: () => import('./views/Instruction/index.vue'),
  },
];

export default routes;
